import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';

export default function extendHeaderSecondary() {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (!items.has('signUp')) {
      return;
    }

    let activationUrl = 'https://authserver.cjlu.edu.cn/retrieve-password/accountActivation/index.html#/';

    items.replace(
      'signUp',
      <a href={activationUrl} className="Button Button--link" target="_blank" rel="noreferrer">
        账号激活
      </a>
    );
  });
}
